import React, { createContext, useContext, useState } from "react"
import { Popup } from "../components"

interface PopupContextProps {
    showPopup: (title: string, message?: string, onOk?: () => void) => void
}

const PopupContext = createContext<PopupContextProps | undefined>(undefined)

export const usePopup = () => {
    const context = useContext(PopupContext)
    if (!context)
        throw new Error("usePopup must be used within PopupProvider")
    return context
}

export const PopupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [visible, setVisible] = useState(false)
    const [title, setTitle] = useState("")
    const [message, setMessage] = useState("")
    const [onOk, setOnOk] = useState<() => void>()

    const showPopup = (popupTitle: string, popupMessage?: string, onOk?: () => void) => {
        setTitle(popupTitle)
        setMessage(popupMessage || "")
        setVisible(true)
        setOnOk(() => onOk)
    }

    const hidePopup = () => {
        setVisible(false);
        setTitle("");
        setMessage("");
        setOnOk(undefined);
    };

    const onOkClicked = () => {
        onOk?.()
        hidePopup()
    }

    return (
        <PopupContext.Provider value={{ showPopup }}>
            {children}

            <Popup visible={visible} title={title} message={message} onOk={onOkClicked} onClose={hidePopup} />
        </PopupContext.Provider>
    )
}
